import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {
  ChatExplorer,
  ChatExport,
  Dashboard,
  EmailCapture,
  Login,
  Settings,
  Sources,
  Users,
} from './pages';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat-explorer"
          element={
            <ProtectedRoute>
              <ChatExplorer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat-export"
          element={
            <ProtectedRoute>
              <ChatExport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute requireSuperAdmin>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sources"
          element={
            <ProtectedRoute requireSuperAdmin>
              <Sources />
            </ProtectedRoute>
          }
        />
        <Route
          path="/email-capture"
          element={
            <ProtectedRoute requireSuperAdmin>
              <EmailCapture />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute requireSuperAdmin>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
